import React, { FunctionComponent } from 'react';

import { useTranslation } from 'react-i18next';

import { Locale } from 'common/comments2/Comments2.types';
import { ContextProps } from 'reviews2/feed/review-yeti/Review.types';
import { Collage } from 'social/common/collage/Collage';

import 'reviews2/feed/review-yeti/template/field/TemplateFieldComment.scss';

const MAX_MEDIA_COUNT = 4;
const SUPPORTED_MEDIA_REGEX = /photo|sticker|video/i;

export const TemplateFieldComment: FunctionComponent<ContextProps> = ({ context }) => {
    const { t } = useTranslation(['reviews2']);
    const { review } = context;
    const supportedMedia = review.expanded_post_media?.filter((media: any) => SUPPORTED_MEDIA_REGEX.test(media.format));
    const unsupportedMedia = review.expanded_post_media?.filter(
        (media: any) => SUPPORTED_MEDIA_REGEX.test(media.format) === false,
    );

    if (!review!.raw_body_text && !review!.expanded_post_media?.length) {
        return null;
    }

    const isTranslated = review!.language !== Locale.English && review!.translated_body_text;
    const reviewText = isTranslated ? review!.translated_body_text : review!.raw_body_text;

    return (
        <div className="r4e-review-template-field-comment">
            <div className="r4e-review-text">
                <div className="r4e-review-display-text mb-2">
                    {isTranslated ? `(${t('TRANSLATED_BY_REPUTATION')}) ` : ''}
                    {/* eslint-disable-next-line react/no-danger */}
                    <span dangerouslySetInnerHTML={{ __html: reviewText! }} />
                </div>
                {isTranslated && (
                    <div className="r4e-review-original-text">
                        {/* eslint-disable-next-line react/no-danger */}({t('ORIGINAL_TEXT')}){' '}
                        <span dangerouslySetInnerHTML={{ __html: review?.raw_body_text! }} />
                    </div>
                )}
            </div>
            {supportedMedia?.length ? (
                <div className="r4e-review-medias">
                    <Collage
                        openModalOnMediaClick
                        maxCount={MAX_MEDIA_COUNT}
                        galleryData={supportedMedia.map((media: any) => {
                            return {
                                url: media.url || media.media_url,
                                type: /photo|sticker$/i.test(media.format) ? 'image' : 'video',
                            };
                        })}
                    />
                </div>
            ) : null}
            {unsupportedMedia?.length ? (
                <div className="unsupported-media">
                    {t('REPLY_UNSUPPORTED_MEDIA_COUNT', { count: unsupportedMedia.length })}
                </div>
            ) : null}
        </div>
    );
};
